export const downloadImage = (src: string, name: string): void => {
  const link = document.createElement('a')
  link.href = src
  link.setAttribute('download', name)

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
